import React, { forwardRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { accessibilityPropCheck } from 'chameleon/ui-stack/utilities/utils';

const Card = forwardRef(
  (
    {
      direction,
      accessibility,
      children,
      bgColor,
      className,
      onAnimationEnd,
      ...otherProps
    },
    ref,
  ) => {
    const cardStyle = cn('rounded-lg flex', className, [
      direction === 'horizontal' ? 'flex-row' : 'flex-col',
      bgColor,
    ]);

    const { ariaLabel, ariaLabelledBy, title } = accessibility;

    const accessibilityProps = {
      title,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
    };

    return (
      <div
        className={cardStyle}
        {...accessibilityProps}
        {...otherProps}
        onAnimationEnd={onAnimationEnd}
        ref={ref}
      >
        {children}
      </div>
    );
  },
);

Card.propTyps = {
  accessibility: accessibilityPropCheck,
  direction: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,
  bgColor: PropTypes.string,
  onAnimationEnd: PropTypes.func,
};

Card.defaultProps = {
  direction: 'horizontal',
  accessibility: {
    title: 'Card',
    'aria-label': '',
    'aria-labelledby': '',
  },
  onAnimationEnd: null,
};

export default Card;
